import { TemplatePosition } from 'entities/campaign/rulesets/template-position';
import { DomainRule } from '../../types';

export interface EmbeddedPositionRequiredRuleDto {
  position: TemplatePosition;
}

export const EmbeddedPositionRequiredRuleKey = 'embeddedPositionRequiredRule';

export const EmbeddedPositionRequiredRule = (dto: EmbeddedPositionRequiredRuleDto): DomainRule => {
  if (!dto.position) {
    return {
      result: 'fail',
      ruleKey: EmbeddedPositionRequiredRuleKey,
    };
  }

  return {
    result: 'pass',
    ruleKey: null,
  };
};
